<ng-container *ngIf="isLoading() ; else content">


    <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
</ng-container>

<ng-template #content>



    <div class="w-full md:px-[3.5rem] flex justify-center md:mx-10 mt-10">
        <div class="md:container md:mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-20 mt-12 md:mt-20">

            @for(auction of auctions; track $index){
            <a class="block bg-white shadow-md rounded-lg p-3   max-w-[333px]">

                <div class=" relative flex justify-center items-center ">
                    <div class="flex justify-center  "> <a [href]="getAuctionUrl(auction)">
                            @if(auction?.auctionHeroImageUrl)
                            {
                            <img loading="lazy"
                                [src]="absoluteMediaUriService.getAbsoluteMediaUri(auction.auctionHeroImageUrl)"
                                class="object-fill rounded-lg cursor-pointer w-[450px] h-[160px] aspect-[16/9]">
                            }@else
                            {
                            <img loading="lazy" [src]="'auction-no-image.png'"
                                class="object-fill rounded-lg cursor-pointer w-[450px] h-[160px] aspect-[16/9]">
                            }
                        </a>
                    </div>
                    <div class="absolute top-0 left-0  w-full flex justify-between items-start px-3 pt-2">
                        <span
                            class=" bg-white px-3 py-0.5 text-xs rounded-[10px] font-dm-sans text-[var(--charcoal)]  whitespace-nowrap"
                            style="box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);">
                            {{ auction.orgCause }}
                        </span>

                        <fa-icon [icon]="auction.isFavorite ? faBookmarkSolid :  faBookmarkRegular"
                            class="text-white cursor-pointer" (click)="toggleFavorite(auction)"></fa-icon>
                    </div>
                </div>

                <div class="mx-auto py-10">
                    <a [href]="getAuctionUrl(auction)">
                        <h3 class="text-[var(--dark-teal)]  font-noto-serif text-lg font-bold cursor-pointer hover:underline break-words whitespace-normal "
                            [innerHTML]="smartTitleCase(auction.orgName) | sanitizeHtmlText">

                        </h3>
                    </a>
                    <p class="mt-5 text-[var(--fs-dark)] text-sm"> {{
                        dateFormatService.formatDateWithTimezone(auction.timezone, auction.auctionClosingDate )}}
                        <span class="text-sm text-[var(--sky-blue)] font-medium">Close date</span>
                    </p>
                    <p>
                        <fa-icon [icon]="faLocationDot" class="text-[var(--sky-blue)]"></fa-icon>
                        <span class="ml-4 text-[var(--fs-dark)]  text-sm">{{smartTitleCase(auction.orgCity)}}
                            {{auction.orgState}}</span>
                    </p>
                </div>

                <p class=" text-center text-[var(--charcoal)]  font-medium italic text-sm ">{{
                    timeLeftService.getTimeLeft(auction.auctionOpeningDate, auction.auctionClosingDate) }}
                </p>
            </a>
            }

        </div>
    </div>
</ng-template>